import { referAndEarnLogoutFaq } from '@helpers/constants';
import ThreeUsers from '@ui/public/images/refer-and-earn/ThreeUsers.svg';
import TwoUsers from '@ui/public/images/refer-and-earn/TwoUsers.svg';
import gradient1000 from '@ui/public/images/refer-and-earn/1000_gradient.svg';
import gradient2000 from '@ui/public/images/refer-and-earn/2000_gradient.svg';
import texts from '@components/ReferEarn/en.json';
import NextHeadTag from '@ui/molecules/NextHeadTag';
import { HeadTagData } from '@helpers/headTagData';
import dynamic from 'next/dynamic';
import Loading from '@atoms/Loading';
import {useEffect} from "react";
import {logEvent, moengageEventArgsConstants, moengageEventConstants} from "@services/moengage";
const ReferEarnTemplate = dynamic(
    () => import('@ui/templates/ReferEarnTemplate'),
    {
        loading: () => (
            <div className="h-[80vh] flex justify-center items-center">
                <Loading loadText="Refer & Earn" />
            </div>
        ),
    }
);
const ReferAndEarn = () => {
    useEffect(() => {
        logEvent({
            eventName: moengageEventConstants.VIEWED_REFER_AND_EARN_PAGE,
            parameters: {
                [moengageEventArgsConstants.IS_FOR_LOGGED_IN_ONLY]: false
            }
        });
    }, []);
    const referAndEarnSteps = [
        {
            number: `01`,
            text: texts?.ReferAndEarnStep1logout,
        },
        {
            number: `02`,
            text: texts?.ReferAndEarnStep2logout,
        },
        {
            number: `03`,
            text: texts?.ReferAndEarnStep3,
        },
    ];
    const rewardInformation = [
        {
            userImage: TwoUsers,
            rewardImage: gradient1000,
            textOne: texts?.RewardInformationTextOne1000,
            textTwo: texts?.RewardInformationTextTwo1000,
            amount: `500`,
        },
        {
            userImage: ThreeUsers,
            rewardImage: gradient2000,
            textOne: texts?.RewardInformationTextOne2000,
            textTwo: texts?.RewardInformationTextTwo2000,
            amount: `1000`,
        },
    ];

    return (
        <>
            <NextHeadTag {...HeadTagData?.['/referandearn']} />
            <ReferEarnTemplate
                earnFaq={referAndEarnLogoutFaq}
                referAndEarnSteps={referAndEarnSteps}
                rewardInformation={rewardInformation}
                kycCompleteDesc={
                    <div className="p5-regular text-gray-500 text-center mt-4 md:mt-6 xl:mt-8">
                        {texts?.kycCompleteDesc}
                    </div>
                }
                fromLogout={true}
            />
        </>
    );
};

export const getServerSideProps = async (ctx) => {
    try {
        const auth = ctx.req.cookies.AUTH
        if(auth) {
            return {
                redirect: {
                    destination: `/refer-and-earn`,
                    permanent: false,
                },
            };
        }
        return { props: {} };
    } catch (e) {
        return { props: {} };
    }
};

export default ReferAndEarn;
